<template>
    <div>
        <a-breadcrumb class="head-breadcrumb" v-show="$store.getters['file/getPaths'].length">
            <a-breadcrumb-item><span @click="nextFolder(0)">资源中心</span></a-breadcrumb-item>
            <a-breadcrumb-item v-for="(item, index) in $store.getters['file/getPaths']">
                <span @click="nextFolder(index + 1, item.id)">{{ item.name }}</span>
            </a-breadcrumb-item>
        </a-breadcrumb>
        <a-table style="min-width: 800px;"
                :columns="columns"
                 :scroll="{y: 350}"
                :rowKey="record=> JSON.stringify(record)"
                :row-selection="rowSelection"
                :pagination="table.tablePagination"
                :loading="table.tableLoading"
                :locale="table.locale"
                :dataSource="table.tableDataSource">
            <div slot="name" class="table-name" slot-scope="text" :title="text.fileName">
                <svg class="icon" aria-hidden="true">
                    <use v-if="text.fileType === 0" xlink:href="#icon-wenjianleixing-suolvetu-wenjianjia"></use>
                    <use v-if="text.fileType === 5" xlink:href="#icon-wenjianleixing-suolvetu-yasuowenjian"></use>
                    <use v-if="text.fileType === 2" xlink:href="#icon-wenjianleixing-suolvetu-tupianwenjian"></use>
                    <use v-if="text.fileType === 3" xlink:href="#icon-wenjianleixing-suolvetu-shengyinwenjian"></use>
                    <use v-if="text.fileType === 4" xlink:href="#icon-wenjianleixing-suolvetu-shipinwenjian"></use>
                    <use v-if="text.fileType === 1 && ['xls', 'xlsx'].includes(suffix(text.fileName))"
                         xlink:href="#icon-wenjianleixing-suolvetu-gongzuobiao"></use>
                    <use v-if="text.fileType === 1 && ['doc', 'docx'].includes(suffix(text.fileName))"
                         xlink:href="#icon-wenjianleixing-suolvetu-Word"></use>
                    <use v-if="text.fileType === 1 && ['ppt', 'pptx'].includes(suffix(text.fileName))"
                         xlink:href="#icon-wenjianleixing-suolvetu-huandengpian"></use>
                    <use v-if="text.fileType === 1 && suffix(text.fileName) === 'pdf'"
                         xlink:href="#icon-wenjianleixing-suolvetu-huandengpian"></use>
                </svg>
                <a-button @click="nextFolder(text)" v-if="!text.fileType" type="link">{{ text.name }}</a-button>
                <span v-else>{{ text.name + "." + suffix(text.fileName)}}</span>
            </div>
            <div slot="type" slot-scope="text">
                {{ searchFileType[text.fileType] }}
                {{ text.fileType === 1 ? `（${text.fileName.substring(text.fileName.lastIndexOf(".") + 1)}）` : "" }}
            </div>
            <div slot="size" slot-scope="text">{{
                    text.size > 1024 * 1024 ? (text.size / (1024 * 1024)).toFixed(2) + "M"
                        : text.size / 1024 < 1 ? (text.size ? text.size + "B" : "--")
                            : (text.size / 1024).toFixed(2) + "KB"
                }}
            </div>
            <div slot="number" slot-scope="text">
                <a-button type="link" @click="tableContact(text)">{{
                        text.fileType ? text.incidenceNumber : "--"
                    }}
                </a-button>
            </div>
        </a-table>
    </div>
</template>

<script>
import {tableRelevant} from "@/pages/projectImpl/js/utils";
import iconfont from "@/utils/aliIconfont/iconfont";

const columns = [
    {
        title: '资源标题',
        scopedSlots: {customRender: 'name'},
    },
    {
        title: '类型',
        scopedSlots: {customRender: 'type'},
    },
    {
        title: '大小',
        scopedSlots: {customRender: 'size'},
    },
    {
        title: '更新时间',
        sorter: true,
        dataIndex: 'updateTime',
    },
    {
        title: '上传时间',
        sorter: true,
        dataIndex: 'uploadTime',
    }
];

export default {
    data(){
        return{
            columns,
            table: tableRelevant.call(this),
            searchFileType: ["文件夹", "文档 ", "图片", "音频", "视频", "压缩文件"],
            search: {
                name: undefined,
                fileType: undefined,
                id:undefined,
                isAll: false,
            },
            selectedRowKeys: [],
            path:[]
        }
    },
    props:['checkType','dataSource'],
    computed: {
        rowSelection() {
            return {
                type:this.checkType,
                onChange: (selectedRowKeys, selectedRows) => {
                    this.selectedRowKeys = selectedRowKeys;
                    console.log(this.selectedRowKeys)
                },
                getCheckboxProps: record => ({
                    props: {
                        disabled: (record.fileType == 0 && this.checkType !== "checkbox") || this.dataSource && this.dataSource.some( m => record.id == m.fileResourceId),
                    },
                }),
            };
        },
    },
    mounted() {
        this.$store.commit("file/setPaths", []);
        this.getPageList(1)
    },
    methods:{
        getPageList(pageIndex){
            const params = {
                pageIndex: pageIndex || this.table.tablePagination.current,
                pageSize: this.table.tablePagination.pageSize,
                ...this.search
            };
            if (this.checkType == 'radio' && typeof params.fileType === "undefined"){
                params.fileType = [0, 4]
            } else {
                params.isAll = !!params.fileType || !!this.search.name;
            }

            this.table.tableLoading = true;
            this.$http.FileResource.pagelist(params).then(res => {
                const {data, status, message} = res;
                    this.table.tableDataSource = data.items;
                    this.table.tablePagination.total = data.totalCount;
                    this.table.tablePagination.current = data.pageIndex;
                
            }).finally(() => {
              this.table.tableLoading = false;
            })
        },
        nextFolder(val, id) {
            const path = this.$store.getters["file/getPaths"];
            if (typeof val === "number") {
                this.$store.commit("file/setPaths", path.filter((f, i) => i < val));
                this.search.id = id
            } else {
                path.push({
                    name: val.name,
                    id: val.id
                });
                this.$store.commit("file/setPaths", path);
                this.search.id = val.id
            }
            this.search.name = undefined;
            this.search.fileType = undefined;
            this.search.isAll = false;
            this.$emit("nextFolder");
            this.getPageList(1);
        },

        suffix(str, point) {
            if (point) {
                return str.substring(str.lastIndexOf(".")).toLowerCase();
            }
            return str.substring(str.lastIndexOf(".") + 1).toLowerCase();
        }
    }
}
</script>

<style scoped lang="less">
.head-breadcrumb {
    display: flex;
    margin-bottom: 15px;

    span:not(:last-child) {
        cursor: pointer;

        &:hover {
            color: #666;
        }
    }
}
.icon {
    width: 14px;
    height: 14px;
    vertical-align: -0.15em;
    fill: currentColor;
    overflow: hidden;
    margin-right: 5px;
    flex-shrink: 0;
}
.table-name {
    display: flex;
    align-items: center;

    .ant-btn, span {
        display: inline-block;
        padding: 0;
        max-width: 200px;
        height: 23px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}
</style>
